import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import RatingStars from './RatingStars';
import { TestimonialCardProps } from '../types';

const TestimonialCard = ({ testimonial, index }: TestimonialCardProps) => {
  return (
    <div
      className="glass-card rounded-2xl p-8 group"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="flex items-start gap-6 mb-6">
        <div className="relative flex-shrink-0">
          <div className="w-20 h-20 rounded-full overflow-hidden ring-2 ring-accent/20 group-hover:ring-accent/50 transition-all duration-300">
            <Image
              src={testimonial.image}
              alt={testimonial.alt}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-cta rounded-full flex items-center justify-center shadow-brand">
            <Icon name="Quote" size={16} color="white" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-xl font-bold text-white mb-1 truncate">
            {testimonial.name}
          </h3>
          <p className="text-sm text-white/55 mb-2 truncate">
            {testimonial.role} at {testimonial.company}
          </p>
          <RatingStars rating={testimonial.rating} size={16} />
        </div>
      </div>

      <div className="mb-6">
        <p className="text-white/70 leading-relaxed text-sm">
          {testimonial.content}
        </p>
      </div>

      <div className="flex items-center justify-between pt-5 border-t border-white/10">
        <div className="flex items-center gap-2">
          <Icon name="Briefcase" size={14} color="var(--color-accent)" />
          <span className="text-xs text-white/50">{testimonial.projectType}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Calendar" size={14} color="var(--color-accent)" />
          <span className="text-xs text-white/50">{testimonial.date}</span>
        </div>
      </div>

      {testimonial.companyLogo && (
        <div className="mt-6 pt-6 border-t border-border flex justify-center">
          <div className="h-8 opacity-60 group-hover:opacity-100 transition-opacity duration-300">
            <Image
              src={testimonial.companyLogo}
              alt={testimonial.companyLogoAlt || `${testimonial.company} logo`}
              className="h-full w-auto object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TestimonialCard;